import { Platform } from "react-native";

import { useTextDirection, type TextDirection } from "./TextDirection";

/** Props to spread onto leaf RN Text nodes for locale-aware direction and alignment. */
export type TypographyDirectionProps = {
  dir?: TextDirection;
  textAlign?: "start" | "end" | "left" | "right" | "center" | "justify";
};

/** Web branch shape — useful when narrowing on `Platform.OS === "web"`. */
export type TypographyDirectionWeb = {
  platform: "web";
  dir: TextDirection;
  textAlign: "start";
};

/** Native branch shape — useful when narrowing on `Platform.OS !== "web"`. */
export type TypographyDirectionNative = {
  platform: "native";
  dir: undefined;
  textAlign: "left";
};

export type TypographyDirection = TypographyDirectionWeb | TypographyDirectionNative;

export function useTypographyDirection(): TypographyDirectionProps {
  const textDirection = useTextDirection();

  if (Platform.OS === "web") {
    return { dir: textDirection, textAlign: "start" };
  }
  return { dir: undefined, textAlign: "left" };
}
